// Error types and interfaces for consistent error handling

export interface ApiError {
  code: string;
  message: string;
  details?: string;
  field?: string;
  statusCode?: number;
}

export interface AppError {
  type: ErrorType;
  message: string;
  originalError?: Error;
  context?: Record<string, any>;
}

export enum ErrorType {
  // Authentication errors
  AUTH_FAILED = 'AUTH_FAILED',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  UNAUTHORIZED = 'UNAUTHORIZED',

  // Validation errors
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  REQUIRED_FIELD = 'REQUIRED_FIELD',
  INVALID_FORMAT = 'INVALID_FORMAT',

  // CRUD operation errors
  CREATE_FAILED = 'CREATE_FAILED',
  UPDATE_FAILED = 'UPDATE_FAILED',
  DELETE_FAILED = 'DELETE_FAILED',
  FETCH_FAILED = 'FETCH_FAILED',

  // Network errors
  NETWORK_ERROR = 'NETWORK_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',

  // User errors
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  DUPLICATE_USER = 'DUPLICATE_USER',

  // Product errors
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  INVALID_CATEGORY = 'INVALID_CATEGORY',

  // General errors
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
}

export interface ErrorDisplayOptions {
  showToast?: boolean;
  autoHide?: boolean;
  duration?: number;
  allowDismiss?: boolean;
}
